export default __webpack_public_path__ + "static/media/img-dragdrop.6f73a9a3.svg";